const reportsUrls = {
  global: '/v1/tenants/reports/accounts',
};

export default reportsUrls;
